const yup = require("yup");

const createSitting = yup.object({
  examination: yup.string().required("Examination is a required field"),
  scored: yup.string().required("Examination result is a required field"),
  subject: yup.string().required("Examination Subject is a required field"),
});

const deleteResult = yup.object({
  delete: yup.string().required("Delete is a required field").oneOf(["Delete"], "Delete is the expected value"),
});
module.exports = {
  createSitting,
  deleteResult,
};
